import SlackTeamConstants from 'constants/SlackTeamConstants'
import SlackTeamAPI from 'app/api/SlackTeamAPI'
import { captureException, captureResponseException } from 'utils/SentryHelpers'

class SlackTeamActions extends Marty.ActionCreators {

  fetchSlackTeam() {
    this.dispatch(SlackTeamConstants.FETCH_SLACK_TEAM_STARTED)
    return SlackTeamAPI.fetch().then(users => {
      this.dispatch(SlackTeamConstants.FETCH_SLACK_TEAM_FINISHED, users)
    }).catch(error => {
      captureException(error)
      this.dispatch(SlackTeamConstants.FETCH_SLACK_TEAM_FAILED)
    })
  }

  sendInvitationsToSlackDM(users, orgId, scopes) {
    this.dispatch(SlackTeamConstants.INVITE_SLACK_USER_STARTED)
    return SlackTeamAPI.sendInvitations(users, orgId, scopes).then((res) => {
      if (res.ok){
        this.dispatch(SlackTeamConstants.INVITE_SLACK_USER_FINISHED)
        this.app.actions.NotificationActions.pushNotification({
          content: "Your invites have been sent!"
        })
      } else {
        this.app.actions.NotificationActions.pushNotification({
          content: res.message,
          variant: 'red'
        })
        captureResponseException(res)
        this.dispatch(SlackTeamConstants.INVITE_SLACK_USER_FAILED)
      }
    })
  }

}

export default SlackTeamActions



// WEBPACK FOOTER //
// ./src/scripts/actions/SlackTeamActions.js